var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjEtapaB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.127 10.837C10.127 10.4907 10.2682 10.1586 10.5196 9.91371C10.771 9.66882 11.1119 9.53125 11.4674 9.53125H15.9357C16.2913 9.53125 16.6322 9.66882 16.8836 9.91371C17.135 10.1586 17.2762 10.4907 17.2762 10.837V17.8134C17.2762 18.3444 16.6596 18.6535 16.2163 18.3449L13.7016 16.5951L11.1868 18.3449C10.7431 18.6539 10.127 18.3449 10.127 17.8139V10.837Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjEtapaB);
export default __webpack_public_path__ + "static/media/IconProjEtapaB.924848f0c090f8747376f0663bad6197.svg";
export { ForwardRef as ReactComponent };